import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { formatNumber } from "utils/currencyFormat";
import { BtnRuiRoCamDo } from "./ChiTietCamDo/DuNoRuiRo/BtnRuiRoCamDo";
import { BtnNoThuongCamDo } from "./ChiTietCamDo/DuNoThuong/BtnNoThuongCamDo";
import { BtnNoXauCamDo } from "./ChiTietCamDo/DuNoXau/BtnNoXauCamDo";
import { BtnRuiRoTinChap } from "./ChiTietTinChap/DuNoRuiRo/BtnRuiRoTinChap";
import { BtnNoThuongTinChap } from "./ChiTietTinChap/DuNoThuong/BtnNoThuongTinChap";
import { BtnNoXauTinChap } from "./ChiTietTinChap/DuNoXau/BtnNoXauTinChap";
import { BtnRuiRoTraGop } from "./ChiTietTraGop/DuNoRuiRo/BtnRuiRoTraGop";
import { BtnNoThuongTraGop } from "./ChiTietTraGop/DuNoThuong/BtnNoThuongTraGop";
import { BtnNoXauTraGop } from "./ChiTietTraGop/DuNoXau/BtnNoXauTraGop";
import { BtnRuiRoBHTG } from "./ChiTietBHTG/DuNoRuiRo/BtnRuiRoBHTG";
import { BtnNoXauBHTG } from "./ChiTietBHTG/DuNoXau/BtnNoXauBHTG";
import { BtnNoThuongBHTG } from "./ChiTietBHTG/DuNoThuong/BtnNoThuongBHTG";

export const ContentTable = ({ listDuNoChoVay, fromDate, toDate }) => {
  return listDuNoChoVay.map((item, index) => (
    <tr className="active" key={"item" + 1}>
      <td> {index + 1}</td>
      <td>{item.TenKieuVay}</td>
      <td className="red text-right">
        {item.KieuVay === 1 && (
          <BtnRuiRoTinChap
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={3}
          />
        )}
        {item.KieuVay === 2 && (
          <BtnRuiRoTraGop
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={3}
          />
        )}
        {item.KieuVay === 3 && (
          <BtnRuiRoCamDo
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={3}
          />
        )}
        {item.KieuVay === 5 && (
          <BtnRuiRoBHTG item={item} fromDate={fromDate} toDate={toDate}   type={3} />
        )}
      </td>
      <td className="red text-right">
        {item.KieuVay === 1 && (
          <BtnRuiRoTinChap
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={2}
          />
        )}
        {item.KieuVay === 2 && (
          <BtnRuiRoTraGop
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={2}
          />
        )}
        {item.KieuVay === 3 && (
          <BtnRuiRoCamDo
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={2}
          />
        )}
        {item.KieuVay === 5 && (
           <BtnRuiRoBHTG item={item} fromDate={fromDate} toDate={toDate}   type={2} />
        )}
      </td>
      <td className="red text-right">
        {item.KieuVay === 1 && (
          <BtnRuiRoTinChap
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={0}
          />
        )}
        {item.KieuVay === 2 && (
          <BtnRuiRoTraGop
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={0}
          />
        )}
        {item.KieuVay === 3 && (
          <BtnRuiRoCamDo
            item={item}
            fromDate={fromDate}
            toDate={toDate}
            type={0}
          />
        )}
        {item.KieuVay === 5 && (
           <BtnRuiRoBHTG item={item} fromDate={fromDate} toDate={toDate}   type={0} />
        )}
      </td>
    </tr>
  ));
};
